import * as yup from 'yup'
import { DEFAULT_REQUIRED_MESSAGE } from 'src/utils'
import { isEmailValid } from 'utils'

yup.setLocale({
  mixed: {
    required: DEFAULT_REQUIRED_MESSAGE
  }
})

export const validationSchema = yup.object().shape({
  email: yup.string().trim().email('Email inválido').required().test('email-validation', 'Email inválido', value => isEmailValid(value)),
  password: yup.string().trim().required()
})
